$(document).ready(function () {
  //********************************************************************************** //
  // MEGA MENU
  $(".site-nav").on("click", ".menu-has-dropdown-wrap button", function (e) {
    e.stopPropagation(); // prevent click bubbling to document

    const $container = $(this).parents(".site-nav__link-container").first();
    const isActive = $container.hasClass("nav-hover");

    $(".site-nav__link-container").removeClass("nav-hover");

    if (!isActive) {
      $container.addClass("nav-hover");
    }
  });

  // Handle clicks outside the menu to remove nav-hover
  $(document).on("click", function () {
    $(".site-nav__link-container").removeClass("nav-hover");
  });
  $(".site-nav .site-nav__link-container .menu-has-dropdown").on(
    "mouseenter",
    function () {
      const $container = $(this).closest(".site-nav__link-container");
      // Remove 'nav-hover' from all other containers
      $(".site-nav__link-container").not($container).removeClass("nav-hover");
      // Add 'nav-hover' to the current one
      $container.addClass("nav-hover");
    }
  );

  //********************************************************************************** //
  //MOBILE MENU ACCORDION
  $(".menu-accordion li:has(.custom-submenu) .link").click(function () {
    $(this).parents("li").toggleClass(" active ");
    $(this).siblings().removeClass(" active ");
    $(".custom-submenu").stop().slideUp();
    $(".active .custom-submenu").stop().slideDown();
    return false;
  });

  //MATTRESS - ADD VARIANT VALUE TO THE PRODUCT TITLE
  function updateMattressUI() {
    var mattressBadge = $(".mattress-option-badge");
    var customProductTitle = $("#komforto-ciuzinys .custom-product-title");
    var getMattressUpgrade =
      $('.custom-mattress-variant input[type="radio"]:checked').val() ||
      "Premium"; // Default to Premium if no selection

    // console.log("getMattressUpgrade (on load/change): ", getMattressUpgrade);

    if (getMattressUpgrade == "Premium") {
      mattressBadge.addClass("bg-orange");
      $(".premium-mattress").removeClass("d-none").addClass("d-block");
      $(".classic-mattress").removeClass("d-block").addClass("d-none");
    } else {
      mattressBadge.removeClass("bg-orange");
      $(".premium-mattress").removeClass("d-block").addClass("d-none");
      $(".classic-mattress").removeClass("d-none").addClass("d-block");
    }

    // Modify the product title
    customProductTitle.text(function (_, currentProductTitle) {
      return currentProductTitle.replace(/^(Premium |Klasikinis )/, "");
    });

    if (getMattressUpgrade == "Premium" || getMattressUpgrade == "Klasikinis") {
      customProductTitle.prepend(getMattressUpgrade + " ");
    }
  }

  // Run the function on page load
  updateMattressUI();

  // Run the function when the selection changes
  $('.custom-mattress-variant input[type="radio"]').on(
    "change",
    updateMattressUI
  );

  // FAQS ACCORDION
  $(".faq-accordion").on("click", function () {
    $(this).toggleClass("active");

    var panel = $(this).next();

    if (panel.css("display") === "block") {
      panel.css("display", "none");
    } else {
      panel.css("display", "block");
    }
  });

  // FOOTER MENU ACCORDION
  $(".menu-accordion-btn").on("click", function () {
    $(this).toggleClass("active");

    var panel = $(this).next();

    if (panel.css("display") === "block") {
      panel.css("display", "none");
    } else {
      panel.css("display", "block");
    }
  });

  //********************************************************************************** //
  // PRODUCT DESCRIPTION ACCORDION
  $(".accordion-btn").on("click", function () {
    $(this).toggleClass("active");

    var panel = $(this).next();

    if (panel.css("display") === "block") {
      panel.css("display", "none");
    } else {
      panel.css("display", "block");
    }
  });

  // CUSTOM COUNTER
  if ($(".counter-wrap-inner #count").length) {
    let target = 98;
    let count = 0;
    let speed = 30; // speed of counting

    let interval = setInterval(function () {
      if (count < target) {
        count++;
        $(".counter-wrap-inner #count").text(count);
      } else {
        clearInterval(interval);
      }
    }, speed);
  }

  // CONTACT INFO STATUS BAR
  if ($(".contact-status-wrap").length) {
    // Get the start and end times from the input
    var startTime = $(".contact-start-time").val();
    var endTime = $(".contact-end-time").val();

    // Get current time in HH:MM format
    var now = new Date();
    var currentTime = now.toTimeString().slice(0, 5);

    // Check if the current time is between start and end times
    if (currentTime >= startTime && currentTime <= endTime) {
      $(".contact-status-wrap").removeClass("hide");
    } else {
      $(".contact-status-wrap").addClass("hide");
    }
  }

  var variant1Options = $(".swatch--1 input");
  var variant2Fieldset = $(".swatch--2"); // Adjust for your option2 fieldset index

  function handleVariantSelection() {
    var selectedVariant1 = $(".swatch--1 input:checked").val();
    // console.log("SWATCH 1: ", selectedVariant1);
    var availableOptions = window.variantMapping[selectedVariant1] || [];

    // Loop through variant 2 options and hide/show based on mapping
    variant2Fieldset.find('input[type="radio"]').each(function () {
      var optionValue = $(this).val();
      var label = $(this).next("label");

      if (availableOptions.includes(optionValue)) {
        $(this).show();
        label.show();
      } else {
        $(this).hide();
        label.hide();
      }
    });

    // Automatically select the first visible option if the selected one is hidden
    var checkedOption = variant2Fieldset
      .find('input[type="radio"]:checked')
      .val();
    if (!availableOptions.includes(checkedOption)) {
      variant2Fieldset
        .find('input[type="radio"]')
        .filter(":visible")
        .first()
        .prop("checked", true);
    }
  }

  // Listen for change on Variant 1
  variant1Options.on("change", handleVariantSelection);

  // Trigger on load
  handleVariantSelection();

  // VARIANT STATUS CODE
  // REMOVE STOCK CODE ON THE FIRST VARIANT
  var getOptionVal = $(".custom-option-label").val();

  if (getOptionVal == "Bezugart") {
    $(".swatch--1 .custom-variant .stock-circle-legend").css("display", "none");
  }

  var productTemplate =
    $("#product_template").offset().top + $("#product_template").outerHeight();

  $(window).on("scroll", function () {
    const isSmallDevice = $(window).width() <= 890;
    if ($(window).scrollTop() > productTemplate) {
      $(".sticky-cart").fadeIn(); // Show the cart
      $(".footer__block-wrapper").css("padding-bottom", "100px");

      if (isSmallDevice) {
        $(".chatway--trigger-container").css("bottom", "88px");
        $("#bik-chat-iframe").css("bottom", "95px");
      } else {
        $(".chatway--trigger-container").css("bottom", "10px");
        $("#bik-chat-iframe").css("bottom", "10px");
      }
    } else {
      $(".sticky-cart").fadeOut(); // Hide the cart
      $(".footer__block-wrapper").css("padding-bottom", "30px");
      $(".chatway--trigger-container").css("bottom", "10px");
      $("#bik-chat-iframe").css("bottom", "10px");
    }
  });

  $(window).on("scroll", function () {
    const isSmallDevice = $(window).width() <= 890;
    if ($(window).scrollTop() > productTemplate) {
      $(".sticky-cart").fadeIn(); // Show the cart
      $(".footer__block-wrapper").css("padding-bottom", "100px");

      if (isSmallDevice) {
        $(".woot-widget-bubble").css("bottom", "95px");
      } else {
        $(".woot-widget-bubble").css("bottom", "10px");
      }
    } else {
      $(".sticky-cart").fadeOut(); // Hide the cart
      $(".footer__block-wrapper").css("padding-bottom", "30px");
      
      $(".woot-widget-bubble").css("bottom", "10px");
    }
  });

  //********************************************************************************** //
  // GET SELECTED VARIANT FOR STICKY CART
  // FIRST VARIANT
  function formatToGermanMoney(price) {
    const adjustedPrice = price / 100;
    return new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR",
    }).format(adjustedPrice);
  }

  function getFirstSelectedVariant() {
    var selectVariant1 = $(".swatch--1 input:checked").val();
    var selectVariant2 = $(".swatch--2 input:checked").val();
    var getVariantPrice1 = $(".swatch--1 input[data-price]:checked").data(
      "price"
    );
    var getVariantComparePrice1 = $(
      ".swatch--1 input[data-compare-price]:checked"
    ).data("compare-price");
    var formattedVariantPrice1 = formatToGermanMoney(getVariantPrice1);
    var formattedComparePrice1 = formatToGermanMoney(getVariantComparePrice1);
    var getProductAvailable1 = $(
      ".swatch--1 input[data-available]:checked"
    ).data("available");
    var getVariantImage1 = $(".swatch--1 input[data-price]:checked").data(
      "image"
    );

    if (getProductAvailable1 == false) {
      $(".btn-sticky-cart").prop("disabled", true);
      $(".btn-sticky-cart").text("Išparduota");
    } else {
      $(".btn-sticky-cart").removeAttr("disabled", true);
      $(".btn-sticky-cart").text("Įdėti į krepšelį");
    }

    if (selectVariant1) {
      $(".sticky-cart-first-option-value").text(selectVariant1);
      $(".sticky-cart-second-option-value").text(selectVariant2);
      $(".sticky-cart-price").text(formattedVariantPrice1);
      $(".sticky-cart-compare-price").text(formattedComparePrice1);

      if (getVariantImage1) {
        $(".sticky-cart-image img").attr(
          "src",
          "/cdn/shop/" + getVariantImage1
        );
        $(".sticky-cart-image img").attr(
          "data-src",
          "/cdn/shop/" + getVariantImage1
        );
      }

      if (getProductAvailable1 == false) {
        $(".btn-sticky-cart").prop("disabled", true);
      } else {
        $(".btn-sticky-cart").removeAttr("disabled", true);
      }

      if (getVariantComparePrice1 > getVariantPrice1) {
        $(".sticky-cart-product-price").addClass("sticky-cart-sale-price");
      } else {
        $(".sticky-cart-product-price").removeClass("sticky-cart-sale-price");
      }
    }
  }

  // Call the function to handle the first selected variant on page load
  getFirstSelectedVariant();

  // Add an event listener to detect changes to the input
  $(".swatch--1 input").on("change", function () {
    var selectVariant1 = $(".swatch--1 input:checked").val();
    var selectVariant2 = $(".swatch--2 input:checked").val();
    var getVariantPrice1 = $(".swatch--1 input[data-price]:checked").data(
      "price"
    );
    var getVariantComparePrice1 = $(
      ".swatch--1 input[data-compare-price]:checked"
    ).data("compare-price");
    var formattedVariantPrice1 = formatToGermanMoney(getVariantPrice1);
    var formattedComparePrice1 = formatToGermanMoney(getVariantComparePrice1);
    var getProductAvailable1 = $(
      ".swatch--1 input[data-available]:checked"
    ).data("available");
    var getVariantImage1 = $(".swatch--1 input[data-price]:checked").data(
      "image"
    );

    // VARIANT 2
    var getVariantImage2 = $(".swatch--2 input[data-price]:checked").data(
      "image"
    );
    var getVariantPrice2 = $(".swatch--2 input[data-price]:checked").data(
      "price"
    );
    var getVariantComparePrice2 = $(
      ".swatch--2 input[data-compare-price]:checked"
    ).data("compare-price");
    var formattedVariantPrice2 = formatToGermanMoney(getVariantPrice2);
    var formattedComparePrice2 = formatToGermanMoney(getVariantComparePrice2);

    if (getProductAvailable1 == false) {
      $(".btn-sticky-cart").prop("disabled", true);
      $(".btn-sticky-cart").text("Išparduota");
    } else {
      $(".btn-sticky-cart").removeAttr("disabled", true);
      $(".btn-sticky-cart").text("Įdėti į krepšelį");
    }

    if (selectVariant1) {
      $(".sticky-cart-first-option-value").text(selectVariant1);
      $(".sticky-cart-second-option-value").text(selectVariant2);
      $(".sticky-cart-price").text(formattedVariantPrice1);
      $(".sticky-cart-compare-price").text(formattedComparePrice1);

      if (getVariantImage1) {
        $(".sticky-cart-image img").attr(
          "src",
          "/cdn/shop/" + getVariantImage1
        );
        $(".sticky-cart-image img").attr(
          "data-src",
          "/cdn/shop/" + getVariantImage1
        );
      }

      if (getVariantComparePrice1 > getVariantPrice1) {
        $(".sticky-cart-product-price").addClass("sticky-cart-sale-price");
      } else {
        $(".sticky-cart-product-price").removeClass("sticky-cart-sale-price");
      }
    }
  });

  // SECOND VARIANT
  function getSecondSelectedVariant() {
    var selectVariant2 = $(".swatch--2 input:checked").val();
    var getVariantPrice2 = $(".swatch--2 input[data-price]:checked").data(
      "price"
    );
    var getVariantComparePrice2 = $(
      ".swatch--2 input[data-compare-price]:checked"
    ).data("compare-price");
    var formattedVariantPrice2 = formatToGermanMoney(getVariantPrice2);
    var formattedComparePrice2 = formatToGermanMoney(getVariantComparePrice2);
    var getProductAvailable2 = $(
      ".swatch--2 input[data-available]:checked"
    ).data("available");
    var getVariantImage2 = $(".swatch--2 input[data-price]:checked").data(
      "image"
    );

    if (getProductAvailable2 == false) {
      $(".btn-sticky-cart").prop("disabled", true);
      $(".btn-sticky-cart").text("Išparduota");
    } else {
      $(".btn-sticky-cart").removeAttr("disabled", true);
      $(".btn-sticky-cart").text("Įdėti į krepšelį");
    }

    if (selectVariant2) {
      $(".sticky-cart-second-option-value").text(selectVariant2);
      $(".sticky-cart-price").text(formattedVariantPrice2);
      $(".sticky-cart-compare-price").text(formattedComparePrice2);

      if (getVariantImage2) {
        $(".sticky-cart-image img").attr(
          "src",
          "/cdn/shop/" + getVariantImage2
        );
        $(".sticky-cart-image img").attr(
          "data-src",
          "/cdn/shop/" + getVariantImage2
        );
      }

      if (getVariantComparePrice2 > getVariantPrice2) {
        $(".sticky-cart-product-price").addClass("sticky-cart-sale-price");
      } else {
        $(".sticky-cart-product-price").removeClass("sticky-cart-sale-price");
      }
    }
  }

  // Call the function to handle the first selected variant on page load
  getSecondSelectedVariant();

  // Add an event listener to detect changes to the input
  $(".swatch--2 input").on("change", function () {
    var selectVariant2 = $(".swatch--2 input:checked").val();
    var getVariantPrice2 = $(".swatch--2 input[data-price]:checked").data(
      "price"
    );
    var getVariantComparePrice2 = $(
      ".swatch--2 input[data-compare-price]:checked"
    ).data("compare-price");
    var formattedVariantPrice2 = formatToGermanMoney(getVariantPrice2);
    var formattedComparePrice2 = formatToGermanMoney(getVariantComparePrice2);
    var getProductAvailable2 = $(
      ".swatch--2 input[data-available]:checked"
    ).data("available");
    var getVariantImage2 = $(".swatch--2 input[data-price]:checked").data(
      "image"
    );

    if (getProductAvailable2 == false) {
      $(".btn-sticky-cart").prop("disabled", true);
      $(".btn-sticky-cart").text("Išparduota");
    } else {
      $(".btn-sticky-cart").removeAttr("disabled", true);
      $(".btn-sticky-cart").text("Įdėti į krepšelį");
    }

    if (selectVariant2) {
      $(".sticky-cart-second-option-value").text(selectVariant2);
      $(".sticky-cart-price").text(formattedVariantPrice2);
      $(".sticky-cart-compare-price").text(formattedComparePrice2);

      if (getVariantImage2) {
        $(".sticky-cart-image img").attr(
          "src",
          "/cdn/shop/" + getVariantImage2
        );
        $(".sticky-cart-image img").attr(
          "data-src",
          "/cdn/shop/" + getVariantImage2
        );
      }

      if (getVariantComparePrice2 > getVariantPrice2) {
        $(".sticky-cart-product-price").addClass("sticky-cart-sale-price");
      } else {
        $(".sticky-cart-product-price").removeClass("sticky-cart-sale-price");
      }
    }
  });

  var stickyAvailable = $(".sticky-available").val();

  if (stickyAvailable.length != 0) {
    if (stickyAvailable == "false") {
      console.log("Disable button");
      $(".btn-sticky-cart").prop("disabled", true);
      $(".btn-sticky-cart").text("Išparduota");
    } else {
      $(".btn-sticky-cart").removeAttr("disabled", true);
      $(".btn-sticky-cart").text("Įdėti į krepšelį");
    }
  }
});

//********************************************************************************** //
//HERO COUNTDOWN TIMER
// Set the date we're counting down to
var getCountDownDate = $("#get-hero-countdown-date").val();
var countDownDate = new Date(getCountDownDate).getTime();

// Update the countdown every 1 second
var countdownfunction = setInterval(function () {
  // Get today's date and time
  var now = new Date().getTime();

  // Find the distance between now and the countdown date
  var distance = countDownDate - now;

  // Time calculations for days, hours, minutes, and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  // Loop through all countdown elements (if you have multiple slides)
  document.querySelectorAll("#hero-countdown").forEach(function (countdown) {
    countdown.querySelector("#days").innerHTML = days;
    countdown.querySelector("#hours").innerHTML = hours;
    countdown.querySelector("#minutes").innerHTML = minutes;
    countdown.querySelector("#seconds").innerHTML = seconds;
  });

  // If the countdown is over, display "EXPIRED"
  if (distance < 0) {
    clearInterval(countdownfunction);
    document.querySelectorAll("#hero-countdown").forEach(function (element) {
      element.style.display = "none";
    });
  }
}, 1000);

//********************************************************************************** //
// REMOVE RATING TEXT ON MOBILE
var removeTextRating = setInterval(function () {
  document
    .querySelectorAll(".mobile-menu-rating .jdgm-prev-badge__text")
    .forEach(function (element) {
      // console.log("REMOVE RATING");
      // Replace the text and assign it back to textContent
      element.textContent = element.textContent.replace(" Atsiliepimai", "");
    });
}, 1000);
var changeRatingLabel = setInterval(function () {
  document
    .querySelectorAll(".featured-collection__product .jdgm-prev-badge__text")
    .forEach(function (element) {
      // console.log("REMOVE RATING");
      // Replace the text and assign it back to textContent
      element.textContent = element.textContent.replace(
        " reviews",
        " Atsiliepimai"
      );
      element.textContent = element.textContent.replace(
        " review",
        " Atsiliepimai"
      );
    });
}, 1000);

//********************************************************************************** //
// CUSTOM TABS
document.addEventListener("DOMContentLoaded", () => {
  // Select all tab buttons
  const tabButtons = document.querySelectorAll(".kk-tab-buttons .kk-tab-btn");

  // Select all tab content sections
  const tabContents = document.querySelectorAll(".kk-tab-content .kk-tab-pane");

  tabButtons.forEach((button, index) => {
    button.addEventListener("click", () => {
      // Remove 'active' class from all buttons and content sections
      tabButtons.forEach((tab) => tab.classList.remove("active"));
      tabContents.forEach((content) => content.classList.remove("active"));

      // Add 'active' class to the clicked button
      button.classList.add("active");

      // Add 'active' class to the corresponding content section
      tabContents[index].classList.add("active");
    });
  });
});

//********************************************************************************** //
// OPEN CHATWAY APP
document.addEventListener("DOMContentLoaded", function () {
  function checkTime() {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();

    // Show button if time is 4:30 PM or later
    if (hours > 16 || (hours === 16 && minutes >= 30)) {
      document.getElementById("chat-laura").href =
        "javascript:window.bik_widget.open();";
    } else {
      document.getElementById("chat-laura").href =
        "javascript:$chatway.openChatwayWidget();";
    }
  }

  checkTime(); // Run function on page load
});

/*****************************************************************************************/
//OUT-OF-STOCK PRODUCT
document.addEventListener("DOMContentLoaded", function () {
  const productDataElement = document.getElementById("ProductData");
  const variantMetafieldElement = document.getElementById(
    "VariantDataWithMetafields"
  );
  const shippingMetafieldElement = document.getElementById(
    "ProductShippingMetafield"
  );
  const shippingInfo = document.getElementById("shipping-info");
  const soldOutInfo = document.getElementById("sold-out-info");
  const shippingTextElement = document.getElementById("shipping-text");

  if (
    !productDataElement ||
    !variantMetafieldElement ||
    !shippingMetafieldElement
  )
    return;

  const product = JSON.parse(productDataElement.textContent);
  const variants = product.variants;

  const variantsWithMetafields = JSON.parse(
    variantMetafieldElement.textContent
  );
  const shippingMetafieldData = JSON.parse(
    shippingMetafieldElement.textContent
  );
  const optionGroups = document.querySelectorAll("[data-option-index]");

  function updateOptionAvailability() {
    const selectedOptions = [];

    // 1. Capture selected options
    optionGroups.forEach((group, index) => {
      const selectedInput = group.querySelector(
        '.custom-variant input[type="radio"]:checked, button.selected, .selected'
      );
      selectedOptions[index] = selectedInput ? selectedInput.value : null;
    });

    // 2. Mark unavailable options
    optionGroups.forEach((group, optionIndex) => {
      const inputs = group.querySelectorAll('input[type="radio"]');

      inputs.forEach((input) => {
        const optionValue = input.value;
        const label = group.querySelector(`label[for="${input.id}"]`);
        if (!label) return;

        const testOptions = [...selectedOptions];
        testOptions[optionIndex] = optionValue;

        const trimmedTestOptions = testOptions.slice(0, optionIndex + 1);

        const hasAvailableVariant = variants.some((variant) => {
          const trimmedVariantOptions = variant.options.slice(
            0,
            optionIndex + 1
          );
          return (
            trimmedVariantOptions.every((opt, i) => {
              return !trimmedTestOptions[i] || trimmedTestOptions[i] === opt;
            }) && variant.available
          );
        });

        if (!hasAvailableVariant) {
          label.classList.add("unavailable");
        } else {
          label.classList.remove("unavailable");
        }
      });
    });

    // 3. Determine the selected variant (fully selected)
    const selectedVariant = variants.find((variant) =>
      variant.options.every((opt, i) => selectedOptions[i] === opt)
    );

    if (selectedVariant) {
      const variantWithMetafield = variantsWithMetafields.variants.find(
        (v) => v.id === selectedVariant.id
      );

      if (selectedVariant.available) {
        shippingInfo.classList.remove("d-none");
        soldOutInfo.classList.add("d-none");

        const fallbackShippingText = shippingMetafieldData.shipping || "";

        shippingTextElement.textContent =
          variantWithMetafield?.metafields?.custom?.custom_shipping_text ||
          fallbackShippingText;
      } else {
        shippingInfo.classList.add("d-none");
        soldOutInfo.classList.remove("d-none");
      }
    } else {
      // No valid full selection
      shippingInfo.classList.add("d-none");
      soldOutInfo.classList.add("d-none");
    }
  }

  // Watch for changes
  optionGroups.forEach((group) => {
    group.addEventListener("change", updateOptionAvailability);
    group.addEventListener("click", updateOptionAvailability);
  });

  // Run on load
  updateOptionAvailability();
});

